const styles = {
  container: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    '-webkit-box-orient': 'vertical',
  },
  preWrapContainer: {
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    width: '100%',
  },
};

export default styles;
